'use strict';exports.__esModule = true;exports.getLocationWithLocale = undefined;var _reactRouter = require('react-router');
var _appendLocale = require('./appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getLocationWithLocale = exports.getLocationWithLocale = function getLocationWithLocale(locale, routeData) {
  var currentLocation = '';
  var searchPart = '';

  if (routeData && routeData.location === 'articles' && routeData.optionType) {
    currentLocation = '/articles';
  } else if (_reactRouter.browserHistory) {var _browserHistory$getCu =
    _reactRouter.browserHistory.getCurrentLocation(),pathname = _browserHistory$getCu.pathname,search = _browserHistory$getCu.search;
    var languagesShortNames = _constants.languages.map(function (item) {return item.value;});
    var languageFromRoute = pathname.split('/')[1].length < 3 ?
    pathname.substr(1, 2) :
    '';
    searchPart = search || '';
    currentLocation = languagesShortNames.indexOf(languageFromRoute) !== -1 ? pathname.substring(3) : pathname;
  }

  return (0, _appendLocale2.default)(locale, '' + currentLocation + searchPart);
};

var changeLocale = function changeLocale(locale, routeData) {
  var location = getLocationWithLocale(locale, routeData);
  _reactRouter.browserHistory.push(location);
};exports.default =


changeLocale;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/changeLocale.js
// module id = 575
// module chunks = 0